








































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { $http } from '@/axios';
import { getStorage } from '@/utils/storage';
import { initPageParams } from '@/utils/constants';
import { IPageData, IPageParam } from '@/store/types';
import Modal from '@/components/dialog/Modal.vue';
import PageList from '@/components/page/Index.vue';

type IOrgPage = Promise<IPageData<IOrg>>;

interface IdProp {
  mainId: number;       // 父组织id
  subId: number | null; // 子组织id
}

// 组织 record
interface IOrg {
  id: number;           // 组织id
  code: string;         // 组织编码
  name: string;         // 组织名称
  orgType: number;      // 组织类型
  hasSubOrg?: boolean;  // 是否有子组织
}

// 组织查询入参
interface IParams {
  pageNum: number;
  pageSize: number;
  search?: string;
}

@Component({
  components: { Modal, PageList },
})
export default class OrgInput extends Vue {
  // 初始值
  @Prop() public ids!: IdProp | null;

  // 占位文字
  @Prop({ default: '请选择组织' }) public placeholder!: string;

  // 是否显示清除按钮
  @Prop({ type: Boolean, default: true }) public clearable!: boolean;

  // 是否禁用组织
  @Prop({ type: Boolean, default: false }) public disabled!: boolean;

  // 是否隐藏信息提示
  @Prop({ type: Boolean, default: false }) public hideDetails!: boolean;

  // 是否显示子组织
  @Prop({ type: Boolean, default: false }) public showSubOrg!: boolean;

  // 验证规则
  @Prop({ type: Array, default: () => [] }) public rules!: (value: string | null) => string | boolean;

  public search = '';
  public orgName = '';
  public visible = false;
  public loading = false;
  public pageNum = 0;
  public pageSize = 0;
  public pageTotal = 0;
  public orgItems: IOrg[] = [];   // 组织列表
  public navItems: IOrg[] = [];   // 组织导航路径
  public selection: IOrg[] = [];  // 已选择的组织
  public parentOrg: IOrg | null = null; // 父组织
  public params: IParams = { ...initPageParams }; // 列表搜索参数
  public userInfo = JSON.parse(getStorage('userInfo') || '{}');
  public headers = [{ text: '组织编码', value: 'code' }, { text: '组织名称', value: 'name' }];

  public get initValue() {
    const isPlatform = this.userInfo.orgType === 0;
    return this.ids ? { isPlatform, ...this.ids } : null;
  }

  // 是否显示子组织跳转链接
  public showSub(record: IOrg) {
    return this.showSubOrg && !!record.hasSubOrg;
  }

  // 清除已选择的组织
  public onClear() {
    this.orgName = '';
    this.selection = [];
    this.$emit('change', null);
  }

  // 提交
  public onSubmit() {
    const record = this.selection[0];
    this.orgName = record ? record.name : '';
    this.visible = false;
    this.$emit('change', record || null);
  }

  // 查看父组织列表
  public onViewParentOrg() {
    this.search = '';
    this.selection = [];
    this.parentOrg = null;
    this.params = { pageNum: 1, pageSize: this.pageSize };
    this.fetchMainOrgs();
  }

  // 查看子组织列表
  public onViewSubOrg(record: IOrg) {
    this.search = '';
    this.selection = [];
    this.parentOrg = record;
    this.params = { pageNum: 1, pageSize: this.pageSize };
    this.fetchSubOrgs();
    this.fetchOrgNav();
  }

  // 搜索
  public onSearch() {
    const search = (this.search || '').trim();
    const params = { pageNum: 1, pageSize: this.pageSize };
    this.params = search ? { ...params, search } : { ...params };
    this.parentOrg ? this.fetchSubOrgs() : this.fetchMainOrgs();
  }

  // 清空搜索
  public onResearch() {
    this.params = { pageNum: 1, pageSize: this.pageSize };
    this.parentOrg ? this.fetchSubOrgs() : this.fetchMainOrgs();
  }

  // 翻页
  public onPageChange(pagination: IPageParam) {
    this.params = { ...this.params, ...pagination };
    this.parentOrg ? this.fetchSubOrgs() : this.fetchMainOrgs();
  }

  // 查询父组织列表
  public fetchMainOrgs() {
    this.loading = true;
    const queryMianOrg: IOrgPage = $http.post('/baseinfo/enterprise', this.params);
    queryMianOrg.then((res) => this.setPageData(res)).catch(() => this.resetPageData());
  }

  // 查询子组织列表
  public fetchSubOrgs() {
    const orgId = this.parentOrg?.id;
    if (orgId) { 
      this.loading = true;
      const querySubOrgs: IOrgPage = $http.post('/v1/system/suborg/search', { ...this.params, orgId });
      querySubOrgs.then((res) => this.setPageData(res)).catch(() => this.resetPageData());
     }
  }

  // 查询组织导航路径
  public fetchOrgNav() {
    const orgId = this.parentOrg?.id;
    if (orgId) { 
      const queryOrgNav: Promise<IOrg[]> = $http.post('/v1/data/system/org/nav', { orgId });
      queryOrgNav.then((res) => this.setNavData(res)).catch(() => { this.navItems = []; });
    }
  }

  // 设置导航数据
  public setNavData(navData: IOrg[]) {
    const lastIndex = navData.length - 1;
    const isPlatform = this.isPlatformUser;
    this.navItems = navData.map((item, index) => {
      const isLast = index === lastIndex;
      const disable = !isPlatform && (item.orgType === 0);  // 非平台用户禁止导航到平台组织列表
      return {...item, disabled: isLast || disable };
    });
  }

  // 设置分页数据
  public setPageData(pageData: IPageData<IOrg>) {
    this.pageNum = pageData.pageNum;
    this.pageSize = pageData.pageSize;
    this.pageTotal = pageData.total;
    this.orgItems = pageData.list;
    this.loading = false;
  }

  // 重置分页数据
  public resetPageData() {
    this.pageNum = 0;
    this.pageSize = 0;
    this.pageTotal = 0;
    this.orgItems = [];
    this.navItems = [];
    this.selection = [];
    this.loading = false;
  }

  @Watch('initValue', { immediate: true })
  public aChange(value: any) {
    const { isPlatform, mainId, subId } = value;
    if (mainId) {
      this.$nextTick(() => console.log(mainId, subId))
    }
  }

  // 初始化查询列表
  @Watch('isPlatformUser', { immediate: true })
  public onIsPlatformUserChange(isPlatform: boolean) {
    if (isPlatform) {
      this.params = { ...initPageParams };
      this.fetchMainOrgs();
    } else {
      const data = this.userInfo;
      this.parentOrg = { id: data.mainOrgId, code: data.orgCode, name: data.orgName, orgType: data.orgType };
      this.params = { ...initPageParams };
      this.fetchOrgNav();
      this.fetchSubOrgs();
    }
  }

  // 设置初始化选中的组织
  // @Watch('initSelected', { immediate: true })
  // public initSelectedChange(value: { id: number; name: string } | null) {
  //   this.orgName = value?.name || '';
  //   this.selection = value ? [{ ...value, code: '', orgType: -1 }] : [];
  // }
} 
